import {HTTP, ERROR} from '@/http-common';
import Router from '@/router';
import Vue from 'vue';

import {clearUserData} from "../../http-common";

const state = {
  participant: {
    first_name: "Case",
    last_name: "MGR",
    activities_services: [],
    assessments_outcomes: [],
    organization: {
      id:''
    },
    profile: {
      email: ''
    }
  },
  organization_data: {},
  showLoading: true,
  case_managers: [],
};

const mutations = {
  SET_PARTICIPANT(state, data) {
    state.participant = data;
  },
  RESET_PARTICIPANT(state, data) {
    state.participant = data;
    state.participant.first_name = 'Case';
    state.participant.last_name = 'MGR';
  },
  SET_ORGANIZATION_DASHBOARD(state, data) {
    state.organization_data = data;
  },
  SET_MANAGERS(state, data) {
    state.case_managers = data;
  },
  SET_LOADING(state, data) {
    state.showLoading = data;
  }
};

const getters = {
  getParticipant: state => {
    return state.participant;
  },
  getCaseManagers: state => {
    return state.case_managers;
  },
  getLoading: state => {
    return state.showLoading;
  },
  getOrganizationDashboard: state => state.organization_data
};

const actions = {
  loadParticipant: ({commit, dispatch}, payload) => {
    if(payload != undefined) {
      commit('SET_LOADING', true);
      HTTP.post(`participant/dashboard`, {user_id: payload})
        .then(response => {
          ERROR(response);
          if (response.data.status == 'success') {
            commit('SET_PARTICIPANT', response.data.data);
            commit('SET_LOADING', false);
            dispatch('GET_USER_DATA_REFRESH_ACTION', null, { root: true });
          } else {
            Vue.prototype.$notify({
              type: 'error',
              text: response.data.message
            });
            Router.push({name: 'Dashboard'});
          }
        }).catch(err => {
        console.log(err);
      })
    } else {
      commit('RESET_PARTICIPANT', []);
    }
  },
  loadOrganizationDashboard: ({commit}) => {
    commit('SET_LOADING', true);
    HTTP.post(`users/data`)
      .then(response => {
        ERROR(response);
        if (response.data.status == 'success') {
          commit('SET_ORGANIZATION_DASHBOARD', response.data.data);
          commit('SET_USER', response.data.data);
          localStorage.setItem('user_account', JSON.stringify(response.data.data));
          commit('SET_LOADING', false);
          clearUserData();
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
      }).catch(err => {
      console.log(err);
    })
  },
  loadCaseManagers: ({commit}, payload) => {
    HTTP.post(`case-managers/index`)
      .then(response => {
        ERROR(response);
        if(response.data.status == 'success') {
          commit('SET_MANAGERS', response.data.data.managers);
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  },
  REMOVE_PARTICIPANT_ACTION: ({commit}, payload) => {
    HTTP.post(`users/delete`, {user_id: payload.id, password: payload.password})
      .then(response => {
        if(response.data.status == 'success') {
          Vue.prototype.$notify(response.data.data[0]);
          Router.push({name: 'Dashboard'});
        } else {
          Vue.prototype.$notify({
            type: 'error',
            text: response.data.message
          });
        }
        ERROR(response);
      }).catch(err => {
      console.log(err);
    })
  }
};

export default {
  state,
  mutations,
  getters,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/participant.js